import Loading from '../Loading';
import PropTypes from 'prop-types';
import React from 'react';
import {Segment} from 'semantic-ui-react';
import PageHeader from "../PageHeader";

const Page = ({children, isLoading, header}) => (
	<Segment raised>
		<Loading isLoading={isLoading}/>
		<PageHeader>
			{header}
		</PageHeader>
		{children}
	</Segment>
);

Page.defaultProps = {
	isLoading: false
};
Page.propTypes = {
	children: PropTypes.node.isRequired,
	isLoading: PropTypes.bool,
	header: PropTypes.string.isRequired
};

export default Page;
